import { render, staticRenderFns } from "./tbas.vue?vue&type=template&id=4e7abf60&scoped=true&"
import script from "./tbas.vue?vue&type=script&lang=js&"
export * from "./tbas.vue?vue&type=script&lang=js&"
import style0 from "./tbas.vue?vue&type=style&index=0&id=4e7abf60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7abf60",
  null
  
)

export default component.exports